<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                <van-col span="12"><div class="banner-title">我的二维码</div></van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="qrcode-box">
            <div class="qrcode" ref="qrCodeUrl">
            </div>
        </div>
        <div class="qr-text">扫一扫上方二维码，添加到共享空间</div>
    </div>
</template>

<script>
    import QRCode from 'qrcodeliaowei'
    export default {
        name: 'myQr',
        data() {
            return {
                theme: 'light',
                userId: localStorage.getItem('userId')
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.creatQrCode();
        },
        methods: {
            back() {
                this.$router.back();
            },
            creatQrCode() {
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: this.userId, // 需要转换为二维码的内容
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })
            },
        }
    }
</script>

<style scoped>
    .qrcode-box {
        width: 180px;
        height: 180px;
        margin: 30px auto;
        background: #ffffff;
        border-radius: 8px;
    }

    .qrcode {
        padding: 10px;
        width:140px;
        height:140px;
    }

    .qr-text {
        font-size: 15px;
        text-align: center;
        color: var(--text-color-1);
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/02myQr.vue